export function normalizeMetarData(data) {
  return {
    altimeter: data.altimeter ? data.altimeter.repr : null,
    clouds: normalizeCloudList(data.clouds || []),
    dewpoint: data.dewpoint ? data.dewpoint.repr : null,
    flightRules: data.flight_rules,
    rawReport: data.raw,
    remarks: data.remarks,
    temperature: data.temperature ? data.temperature.repr : null,
    time: data.time ? getMetarDate(data.time.repr) : null,
    visibility: data.visibility ? data.visibility.repr : null,
    runwayVisibility: data.runway_visibility || [],
    weather: data.other ? normalizeWeatherData(data.other) : null,
    windDirection: data.wind_direction ? data.wind_direction.repr : null,
    windGust: data.wind_gust ? data.wind_gust.repr : null,
    windSpeed: data.wind_speed ? data.wind_speed.repr : null,
    windVariableDirection: data.wind_variable_direction
  }
}

const getMetarDate = (input) => {
  var now = new Date()
  var year = now.getUTCFullYear()
  var month = now.getUTCMonth()
  var day = input.substring(0, 2)
  var hour = input.substring(2, 4)
  var minute = input.substring(4, 6)
  return new Date(Date.UTC(year, month, day, hour, minute))
}

const normalizeCloudList = (cloudArray) => {
  return cloudArray.map(rec => {
    return {
      coverage: rec.type,
      altitude: ("000" + rec.altitude).slice(-3)
    }
  })
}

const normalizeWeatherData = data => {
  if(data.length === 0) {
    return
  }
  return data
}



// WEBPACK FOOTER //
// ./src/util/avwx.js